// Make sure headers names are lower case in this file
// As axios lower case all the headers before passing then in the response
export const CSRF_HEADER_NAME = 'x-csrf-token';
export const CSRF_LOCAL_STORAGE_KEY = 'csrfToken';
export const USER_ID_LOCAL_STORAGE_KEY = 'userId';
export const USER_ROLE_LOCAL_STORAGE_KEY = 'userRole';
export const USER_ID_SESSION_STORAGE_KEY = 'registrationUserId';
export const EMAIL_SESSION_STORAGE_KEY = 'registrationEmail';
export const DOCUMENT_CLOSED_WHILE_CONNECTED = 'disconnectedWhileConnected';
export const FE_SESSION_ID_KEY = 'fe-session-id';
export const AI_CONTENT_FEEDBACK = 'ai-content-feedback';
export const PREFILL_DOB = 'signup-prefill-dob';
export const PREFILL_PHONE_NUMBER = 'signup-prefill-phone';
export const DEBIT_DEPOSIT_AMOUNT = 'debitDepositAmount';
export const DEBIT_DEPOSIT_FEE = 'debitDepositFee';
export const DEBIT_WITHDRAWAL_AMOUNT = 'debitWithdrawalAmount';
